import { Grid, Typography, styled } from "@mui/material";
import React from "react";
import WebLink from "./web.svg";
import ConnectSuccess from "./success.svg";

const StyledImage = styled("img")({
  width: "100%",
  maxWidth: "80px",
  minHeight: "80px",
  height: "auto",
  display: "block",
  margin: "0 auto",
});

const StyledTypography = styled(Typography)({
  fontSize: "20px",
  fontWeight: 500,
  color: "#263238",
  marginTop: "8px",
  textAlign: "center",
});

const StyledSvg = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  minHeight: "20px",
  transform: "scale(0.8)",
  "& svg": {
    animation: "moveRight 3s infinite ease-in-out",
  },
  "@keyframes moveRight": {
    "0%": {
      transform: "translateX(-10px)",
    },
    "25%": {
      transform: "translateX(-5px)",
    },
    "50%": {
      transform: "translateX(0px)",
    },
    "75%": {
      transform: "translateX(5px)",
    },
    "100%": {
      transform: "translateX(10px)",
    },
  },
});

interface ResellerConnectWidgetProps {
  domainName: string;
}

const ResellerConnectWidget: React.FC<ResellerConnectWidgetProps> = ({
  domainName,
}) => {
  return (
    <div>
      <Grid container spacing={2} justifyContent="center">
        <Grid item md={2} sx={{ textAlign: "center" }}>
          <StyledImage src={WebLink} alt="" />
          <StyledTypography>{domainName}</StyledTypography> 
        </Grid>
        <Grid item md={5.5}>
          <StyledSvg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="901"
              height="60"
              viewBox="0 0 901 60"
              fill="none"
            >
              <path
                d="M4 26C1.79086 26 0 27.7909 0 30C0 32.2091 1.79086 34 4 34V26ZM898.896 32.8284C900.458 31.2663 900.458 28.7337 898.896 27.1716L873.44 1.71573C871.878 0.153631 869.346 0.153631 867.784 1.71573C866.221 3.27783 866.221 5.81049 867.784 7.37258L890.411 30L867.784 52.6274C866.221 54.1895 866.221 56.7222 867.784 58.2843C869.346 59.8464 871.878 59.8464 873.44 58.2843L898.896 32.8284ZM4 34H11.9649V26H4V34ZM27.8947 34H43.8245V26H27.8947V34ZM59.7542 34H75.684V26H59.7542V34ZM91.6138 34H107.544V26H91.6138V34ZM123.473 34H139.403V26H123.473V34ZM155.333 34H171.263V26H155.333V34ZM187.192 34H203.122V26H187.192V34ZM219.052 34H234.982V26H219.052V34ZM250.912 34H266.841V26H250.912V34ZM282.771 34H298.701V26H282.771V34ZM314.631 34H330.56V26H314.631V34ZM346.49 34H362.42V26H346.49V34ZM378.35 34H394.28V26H378.35V34ZM410.209 34H426.139V26H410.209V34ZM442.069 34H457.999V26H442.069V34ZM473.928 34H489.858V26H473.928V34ZM505.788 34H521.718V26H505.788V34ZM537.648 34H553.577V26H537.648V34ZM569.507 34H585.437V26H569.507V34ZM601.367 34H617.297V26H601.367V34ZM633.227 34H649.156V26H633.227V34ZM665.086 34H681.016V26H665.086V34ZM696.946 34H712.876V26H696.946V34ZM728.805 34H744.735V26H728.805V34ZM760.665 34H776.595V26H760.665V34ZM792.525 34H808.454V26H792.525V34ZM824.384 34H840.314V26H824.384V34ZM856.244 34H872.174V26H856.244V34ZM888.103 34H896.068V26H888.103V34Z"
                fill="#035344"
              />
            </svg>
          </StyledSvg>
        </Grid>
        <Grid item md={2} sx={{ textAlign: "center" }}>
          <StyledImage src={ConnectSuccess} alt="" />
          <StyledTypography>Connected</StyledTypography>
        </Grid>
      </Grid>
    </div>
  );
};

export default ResellerConnectWidget;